import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/services/config.service';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { MenuInfo } from 'src/app/models/menu-info';

@Injectable({
  providedIn: 'root'
})
export class AuthServiceService {

  adminGroupInfo;

  menuInfo: MenuInfo[];

  profileInfo = {} as any;


  constructor(
    private http : HttpClient,
    private config: ConfigService,
    private router : Router
  ) { }

  login(data): Observable<any> {
    return this.http.post(this.config.json.apiEndpoint + 'admin/login.on', data);
  }

  loggedin() {
    // return !!localStorage.getItem('token');
    return localStorage.getItem('token') != null;
  }

  redirectToLogin() {
    this.router.navigateByUrl('/login');
  }

  pathValidity(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return true;
  }

  gettoken() {
    return localStorage.getItem('token')
  }

  setSessionStatus() {
    localStorage.setItem('sessionStatus', '0');
  }

  getProfile() {
    this.profileInfo['adminName'] = localStorage.getItem('adminInfo');
    this.profileInfo['mobileNumber'] = localStorage.getItem('mobileNumber');
    if(this.profileInfo) {
      return this.profileInfo;
    }
    return {};
  }

    // pathValidityMain(state: RouterStateSnapshot): boolean {
  //   const pathValues: string[] = state.url.split('/').slice(1);
  //   return !!this.getAvailableMainMenuItems().find(x => x.menuUrl.includes(pathValues[0]));
  // }
  // pathValiditySub(state: RouterStateSnapshot): boolean {
  //   const pathValues: string[] = state.url.split('/').slice(1);
  //   const pathString = '/' + pathValues[0] + '/' + pathValues[1];
  //   if(pathString == '/ui-builder'){
  //     return true
  //   }
  //   return !!this.getAvailableSubMenuItems().find(x => x.menuUrl.startsWith(pathString));
  // }

  // getAvailableMainMenuItems(): MenuInfo[] {
  //   const mainMenuItems: MenuInfo[] = JSON.parse(window.localStorage.getItem('adminGroupInfo')).adminGroupAccessControlList ?? [];
  //   return mainMenuItems.filter(menu => menu.checked === true);
  // }

  // getAvailableSubMenuItems(): MenuInfo[] {
  //   const mainMenuItems = this.getAvailableMainMenuItems();
  //   var subMenuItems = [].concat.apply([], mainMenuItems.map(pipe(x => { return x.subMenu })));
  //   return subMenuItems.filter(menu => menu.checked === true);
  // }

}
